import { IApiResponse } from "../../../@types/api-response.type";
import { IGrid } from "../../../@types/grid.type";
import { IKeyValue } from "../../../@types/key-value.type";
import { IReportMetricsBody } from "../../../@types/reports-metrics.type";
import { IResourceDownload, IResourceFilter } from "../../../@types/resource-filter.type";
import { IResourceGridItem } from "../../../@types/resource-grid-item.type";
import { IResourceType, ISearchResourcesByQuestion, ISearchResourcesByQuestionResponse } from "../../../@types/resource.type";
import { downloadExcel } from "../../../utils/download";
import { getErrorMessage } from "../../../utils/utils";
import { Api } from "../ApiConfig";
import { ApiException } from "../ApiException";

export const getResourceById = async (idResource: string) => {
    try {
        const { data } = await Api.get(`api/Resource/GetResourceById?id=${idResource}`)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar Resource'))
    }
    
}

export const GetResourcesByCustomerName = async (customerName: string) => {
    try {
        const { data } = await Api.get(`api/Resource/GetResourcesByCustomerName?customerName=${customerName}`)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar CustomerResource'))
    }
    
}

export const getResourceByManagerId = async (managerId: string) => {
    try {
        const { data } = await Api.get(`api/Resource/GetResourceByManagerId?managerId=${managerId}`)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar CustomerResource'))
    }
    
}

export const getAllResourceByProjectId = async (projectId: string) => {
    try {
        const { data } = await Api.get(`api/Resource/GetAllResourceByProjectId?projectId=${projectId}`)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar os resources'))
    }
    
}

export const getResourceByFirstnameAndLastname = async (firstname: string, lastname: string) => {
    try {
        const { data } = await Api.get(`api/Resource/GetResourceByFirstnameAndLastname?firstname=${firstname}&lastname=${lastname}`)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar CustomerResource'))
    }
    
}

export const deleteResource = async (idResource: string) => {
    try {
        const { data } = await Api.delete(`api/Resource/DeleteResource/${idResource}`)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao deletar CustomerResource'))
    }
    
}

export const addOrUpdateResource = async (resourceDto: IResourceType) => { 
    try {
        const { data } = await Api.post(`api/Resource/AddOrUpdateResource`, resourceDto)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao criar CustomerResource'))
    }
}

export const searchResources = async (resourceFilter: IResourceFilter) : Promise<IGrid<IResourceGridItem> | ApiException>=> {
    try {
        const response = await Api.post<IApiResponse<IGrid<IResourceGridItem>>>(`api/Resource/SearchResources`, resourceFilter)
        return response.data.result
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar todos osCustomerResource'))
    }
}

export const getAllResources = async (isAllocatable?:boolean, isDismissed?:boolean) : Promise<IKeyValue[] | ApiException>=> {
    const url = `api/Resource/GetAllResources${isAllocatable ? `?isAllocatable=${isAllocatable}` : ''}${isDismissed ? `${isAllocatable ? '&' : '?'}isDismissed=${isDismissed}` : ''}`;
    try {
        const response = await Api.get<IApiResponse<IKeyValue[]>>(url)
        return response.data.result
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar todos Colaboradores'))
    }
}
 
export const getResourcesMetrics = async (resource:IReportMetricsBody) => {
    try {
      const { data } = await Api.post("/api/Resource/GetResourcesMetrics",
        {"id": resource.id, "startTime": resource.startTime, 
            "endTime": resource.endTime, "timeType": resource.timeType}
      );
      
      return data;
    } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao consultar métricas dos Colaboradores'));
    }
  };

  export const getResourcesMetricsByProjectId = async (resource: IReportMetricsBody) => {
    try {
        const { data } = await Api.post("/api/Resource/GetResourcesMetricsByProjectId",
        {"id": resource.id, "startTime": resource.startTime, 
        "endTime": resource.endTime, "timeType": resource.timeType});
        return data;
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao consultar metricas dos Colaboradores por Projeto'))
    } 
  }

  export const getResourcesMetricsByPositionId = async (resource: IReportMetricsBody) => {
    try {
        const { data } = await Api.post("/api/Resource/GetResourcesMetricsByPositionId",
        {"id": resource.id, "startTime": resource.startTime, 
        "endTime": resource.endTime, "timeType": resource.timeType});
        return data;
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao consultar metricas dos Colaboradores por Função'))
    } 
  }

  
export const DownloadResourcesToExcel = async (filters: IResourceDownload) : Promise<void> => {
    try {
        const response = await Api.post(
            `/api/Resource/DownloadResourcesToExcel`, 
            filters  , { responseType: "blob" });

        downloadExcel("Colaboradores", response.data);
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'))
    }    
  }

  
export const downloadResourcesReportToExcel = async (filters: IReportMetricsBody) : Promise<void> => {
    try {
        const response = await Api.post(
            `/api/Resource/DownloadResourcesReportToExcel`, 
            filters  , { responseType: "blob" });
  
        downloadExcel("Relatorio-Colaboradores", response.data);
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'))
    }    
  }

export const searchResourcesByQuestion = async (question: ISearchResourcesByQuestion) : Promise<ISearchResourcesByQuestionResponse[] | ApiException> => { 
    try {
        const { data } = await Api.post<ISearchResourcesByQuestionResponse[]>(`/api/Resource/SearchResourcesByQuestion`, question)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao criar CustomerResource'))
    }
}

export const ResourceService = {
    getResourceById,
    deleteResource,
    addOrUpdateResource,
    getAllResources,
    getResourceByFirstnameAndLastname,
    getResourceByManagerId,
    GetResourcesByCustomerName,
    getResourcesMetrics,
    getResourcesMetricsByPositionId,
    getResourcesMetricsByProjectId,
    DownloadResourcesToExcel,
    downloadResourcesReportToExcel,
    searchResourcesByQuestion
}
